import Vue from "vue";
import { MutationTree } from "vuex";

import Constants from "@/constants/constants";
import { State } from "@/clickbuy/purchase/store/state";
import { Purchase } from "@/clickbuy/purchase/models/purchase.model";
import { Note } from "@/manager/convocation/note.model";
import { BudgetFee } from "@/manager/budget/models/budget-fee.model";
import { FeeInterface } from "@/clickbuy/purchase/models/fee.interface";

export interface Mutations {
  setPurchaseList: { list: Purchase[] };
}

export const mutations: MutationTree<State> = {
  setPurchaseList: (state, payload) => {
    state.list = payload;
  },
  setPurchaseTagList: (state, payload) => {
    state.purchaseTagList = payload;
  },
  setTypeOfPrice: (state, payload) => {
    state.typeOfPrice = payload;
  },
  setAddingUser: (state, payload) => {
    state.addingUser = payload;
  },
  setSelectedClient: (state, payload) => {
    state.selectedClient = payload;
  },
  setInternalBussinessSelected: (state, payload) => {
    state.internalBussinessSelected = payload;
  },
  setBudgetList: (state, payload) => {
    state.budgetList = payload;
  },
  setCurrentBudgetAcceptanceProductPackList: (state, payload) => {
    state.budgetProductsPack = payload;
  },
  setFeeList: (state, payload) => {
    state.feeList = payload;
  },
  newPurchase: (state, payload) => {
    state.list.push(payload);
  },
  newBudget: (state, payload) => {
    state.budgetList.push(payload);
  },
  setCompanionList: (state, payload) => {
    state.companionList = payload;
  },
  setSaleInfo: (state, paylaod) => {
    state.saleInfoList = paylaod;
  },
  updatePurchase: (state, payload) => {
    const index = state.list.map((item: any) => item.id).indexOf(payload.id);
    if (index > -1) {
      const purchase = state.list[index];
      const newPurchase = Object.assign({}, purchase, payload);
      Vue.set(state.list, index, newPurchase);
    }
  },
  updateBudget: (state, payload) => {
    const index = state.budgetList
      .map((item: any) => item.id)
      .indexOf(payload.id);
    if (index > -1) {
      const budget = state.budgetList[index];
      const newBudget = Object.assign({}, budget, payload);
      Vue.set(state.budgetList, index, newBudget);
    } else {
      state.budgetList.push(payload);
    }
  },
  updateBudgetFee: (state, payload) => {
    const budget = state.budgetList.find(
      (budget: any) => budget.id === payload.budget.id
    );
    if (budget && payload.budgetFee.id) {
      const index = (budget as any).budgetFee
        .map((item: any) => item.id)
        .indexOf(payload.budgetFee.id);
      if (index > -1) {
        const budgetFee = (budget as any).budgetFee[index];
        const newBudgetFee = Object.assign({}, budgetFee, payload.budgetFee);
        Vue.set((budget as any).budgetFee, index, newBudgetFee);
      }
    }
  },
  removePurchase: (state, payload) => {
    const index = state.list.map((item: any) => item.id).indexOf(payload.id);
    if (index > -1) {
      state.list.splice(index, 1);
    }
  },
  removeBudget: (state, payload) => {
    const index = state.budgetList
      .map((item: any) => item.id)
      .indexOf(payload.id);
    if (index > -1) {
      state.budgetList.splice(index, 1);
    }
  },
  setBudgetFees: (state, payload) => {
    const budget = state.budgetList.find(
      (budget: any) => budget.id === payload.budgetId
    );
    if (budget) {
      budget.budgetFee = payload.fees;
    }
  },
  setBudgetNotes: (state, payload) => {
    const budgetNoteListIds = state.budgetNoteList.map((item: any) => item.id);
    payload.notes.forEach((note: Note) => {
      const newNote = Object.assign({}, note, {
        ["budgetId"]: payload.budgetId
      });
      const index = budgetNoteListIds.indexOf(note.id);
      if (index > -1) {
        state.budgetNoteList.splice(index, 1, newNote);
      } else {
        state.budgetNoteList.push(newNote);
      }
    });
  },
  newBudgetNote: (state, payload) => {
    state.budgetNoteList.push(payload);
  },
  updateBudgetNote: (state, payload) => {
    const index = state.budgetNoteList
      .map((item: any) => item.id)
      .indexOf(payload.id);
    if (index > -1) {
      const note = state.budgetNoteList[index];
      const newNote = Object.assign({}, note, payload);
      state.budgetNoteList.splice(index, 1, newNote);
    }
  },
  removeBudgetNote: (state, noteId) => {
    const index = state.budgetNoteList
      .map((item: any) => item.id)
      .indexOf(noteId);
    if (index > -1) {
      state.budgetNoteList.splice(index, 1);
    }
  },
  setPurchaseNotes: (state, payload) => {
    const purchaseNoteListIds = state.purchaseNoteList.map((item: any) => item.id);
    payload.notes.forEach((note: Note) => {
      const newNote = Object.assign({}, note, {
        ["purchaseId"]: payload.purchaseId
      });
      const index = purchaseNoteListIds.indexOf(note.id);
      if (index > -1) {
        state.purchaseNoteList.splice(index, 1, newNote);
      } else {
        state.purchaseNoteList.push(newNote);
      }
    });
  },
  newPurchaseNote: (state, payload) => {
    state.purchaseNoteList.push(payload);
  },
  updatePurchaseNote: (state, payload) => {
    const index = state.purchaseNoteList
      .map((item: any) => item.id)
      .indexOf(payload.id);
    if (index > -1) {
      const note = state.purchaseNoteList[index];
      const newNote = Object.assign({}, note, payload);
      state.purchaseNoteList.splice(index, 1, newNote);
    }
  },
  removePurchaseNote: (state, noteId) => {
    const index = state.purchaseNoteList
      .map((item: any) => item.id)
      .indexOf(noteId);
    if (index > -1) {
      state.purchaseNoteList.splice(index, 1);
    }
  },
  removeBudgetCommentNote: (state, commentId) => {
    const index = state.budgetCommentNoteList
      .map((item: any) => item.id)
      .indexOf(commentId);
    if (index > -1) {
      state.budgetCommentNoteList.splice(index, 1);
    }
  },
  updateCompanion: (state, payload) => {
    const index = state.companionList
      .map((item: any) => item.id)
      .indexOf(payload.id);
    if (index > -1) {
      const companion = state.companionList[index];
      const newCompanion = Object.assign({}, companion, payload);
      Vue.set(state.companionList, index, newCompanion);
    }
  },
  setBudgetFeeFromFeeList: (state, payload) => {
    state.currentBudgetAcceptance.budgetFee = [];
    payload.feeList.map((fee: FeeInterface) => {
      const newFee = new BudgetFee();
      newFee.paymentDate = fee.paymentDate;
      newFee.price = fee.money;
      (state.currentBudgetAcceptance as any).budgetFee.push(newFee);
    });
  },
  setCurrentPurchase: (state, payload) => {
    state.currentPurchase = payload;
  },
  setConvocationBalance: (state, payload) => {
    state.convocationBalance = payload;
  },
  setCurrentPurchaseTypeOfProduct: (state, payload) => {
    state.currentPurchaseTypeOfProduct = payload;
  },
  setCurrentBudget: (state, payload) => {
    state.currentBudget = payload;
  },
  setCurrentBudgetAcceptance: (state, payload) => {
    state.currentBudgetAcceptance = payload;
  },
  updateCurrentBudgetAcceptanceDelegationList: (state, payload) => {
    const index = state.currentBudgetAcceptanceDelegationList
      .map((item: any) => item.id)
      .indexOf(payload.id);
    const listLength = state.currentBudgetAcceptanceDelegationList.length;
    if (index > -1 && listLength > 1) {
      state.currentBudgetAcceptanceDelegationList.splice(index, 1);
    } else {
      state.currentBudgetAcceptanceDelegationList.push(payload);
    }
  },
  checkCurrentBudgetAcceptanceConvocationList: state => {
    const convocationsToDelete: string[] = [];
    state.currentBudgetAcceptanceSelectedConvocations.forEach(
      (convocation: any) => {
        const convocationObject = state.currentBudgetAcceptanceConvocationList.find(
          (conv: any) => conv.id === convocation
        );
        const convocationDelegation = (convocationObject as any).delegation.id;
        const delegation = state.currentBudgetAcceptanceDelegationList.find(
          (delegation: any) => {
            return delegation.id === convocationDelegation;
          }
        );
        if (!delegation) {
          convocationsToDelete.push(convocation);
        }
      }
    );
    if (convocationsToDelete.length > 0) {
      state.currentBudgetAcceptanceSelectedConvocations = [];
    }
  },
  setCurrentBudgetAcceptanceDelegationList: (state, payload) => {
    state.currentBudgetAcceptanceDelegationList = payload;
  },
  setCurrentBudgetAcceptanceConvocationList: (state, payload) => {
    state.currentBudgetAcceptanceConvocationList = payload;
  },
  setCurrentBudgetAcceptanceProductList: (state, payload) => {
    state.currentBudgetAcceptanceProductList = payload;
  },
  setCurrentBudgetAcceptanceSelectedConvocations: (state, payload) => {
    state.currentBudgetAcceptanceSelectedConvocations = payload;
  },
  setCurrentBudgetAcceptancePreviousSelectedConvocations: (state, payload) => {
    state.currentBudgetAcceptancePreviousSelectedConvocations = payload;
  },
  clearAcceptanceTimeout: state => {
    clearTimeout(state.acceptanceRequestTimeout);
  },
  setAcceptanceTimeout: (state, payload) => {
    state.acceptanceRequestTimeout = payload;
  },
  setCurrentBudgetAcceptanceMessageInfo: (state, payload) => {
    state.currentBudgetAcceptanceMessageInfo = payload;
    setTimeout(() => {
      state.currentBudgetAcceptanceMessageInfo = "";
    }, Constants.notificationMessageTimeToAppear);
  },
  setUserMoneyFlow: (state, payload) => {
    state.userMoneyFlow = payload;
  },
  setCurrentPurchaseLoading: (state, payload) => {
    state.currentPurchaseLoading = payload;
  },
  setAcceptanceFieldError: (state, payload) => {
    state.acceptanceFieldError = payload;
  },
  fiscalDataList: (state, payload) => {
    state.acceptanceFieldError = payload;
  }
};
